var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegularObj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 196,
    viewBox: "0 0 282 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 35V161H247",
    stroke: "#CDCDD6",
    strokeWidth: 2.72632,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 132L69.2667 122.403L86.5211 99.36L106.848 86.95L147.423 95.875L192.799 64L210.268 95.875L231 74.2",
    stroke: "#2BB8C8",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 128.5C73.366 128.5 76.5 125.366 76.5 121.5C76.5 117.634 73.366 114.5 69.5 114.5C65.634 114.5 62.5 117.634 62.5 121.5C62.5 125.366 65.634 128.5 69.5 128.5Z",
    fill: "#12BB6A",
    stroke: "white",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5 106.5C90.366 106.5 93.5 103.366 93.5 99.5C93.5 95.634 90.366 92.5 86.5 92.5C82.634 92.5 79.5 95.634 79.5 99.5C79.5 103.366 82.634 106.5 86.5 106.5Z",
    fill: "#12BB6A",
    stroke: "white",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.5 94.5C111.366 94.5 114.5 91.366 114.5 87.5C114.5 83.634 111.366 80.5 107.5 80.5C103.634 80.5 100.5 83.634 100.5 87.5C100.5 91.366 103.634 94.5 107.5 94.5Z",
    fill: "#12BB6A",
    stroke: "white",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M146.5 101.5C150.366 101.5 153.5 98.366 153.5 94.5C153.5 90.634 150.366 87.5 146.5 87.5C142.634 87.5 139.5 90.634 139.5 94.5C139.5 98.366 142.634 101.5 146.5 101.5Z",
    fill: "#CAA628",
    stroke: "white",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M192.5 70.5C196.366 70.5 199.5 67.366 199.5 63.5C199.5 59.634 196.366 56.5 192.5 56.5C188.634 56.5 185.5 59.634 185.5 63.5C185.5 67.366 188.634 70.5 192.5 70.5Z",
    fill: "#12BB6A",
    stroke: "white",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M210.5 104.5C214.366 104.5 217.5 101.366 217.5 97.5C217.5 93.634 214.366 90.5 210.5 90.5C206.634 90.5 203.5 93.634 203.5 97.5C203.5 101.366 206.634 104.5 210.5 104.5Z",
    fill: "#F8003B",
    stroke: "white",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M231.5 79.5C235.366 79.5 238.5 76.366 238.5 72.5C238.5 68.634 235.366 65.5 231.5 65.5C227.634 65.5 224.5 68.634 224.5 72.5C224.5 76.366 227.634 79.5 231.5 79.5Z",
    fill: "#12BB6A",
    stroke: "white",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegularObj);
export default __webpack_public_path__ + "static/media/regular_obj.ebb752b16c8accf907cc5622489cb33b.svg";
export { ForwardRef as ReactComponent };